<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-3 page-title">
            <h3 class="text-center mt-2 mal-text custom-title">{{ program.title || 'സ്നേഹ സ്പർശം' }}</h3>
        </div>
    </div>

    <div class="section text-center" v-if="loading">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="section pt-1 pb-3" v-if="!loading && program.id">
        <div class="card">
            <div class="card-body">
                <pre class="mal-text intro-text mb-3">{{ program.intro_text }}</pre>
                <router-link
                    :to="'/org/' + $route.params.sub_level + '/' + $route.params.id + '/sneha-sparsham/' + program.id + '/apply'"
                    class="btn btn-primary btn-block btn-lg mal-text"
                >
                    അപേക്ഷയിലേക്ക് പോകുക
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from "@/services/user.service";

export default {
    name: "SnehaSparshamIntro",
    data() {
        return {
            loading: true,
            program: {},
        };
    },
    mounted() {
        this.$root.updateParent("സ്നേഹ സ്പർശം");
        this.loadProgram();
    },
    methods: {
        loadProgram() {
            UserService.authPostRequest("get-sneha-sparsham-program", {
                program_id: this.$route.params.program_id,
            }).then((res) => {
                this.loading = false;
                if (res.data.status === "success") {
                    this.program = res.data.data.program || {};
                }
            }).catch(() => {
                this.loading = false;
            });
        },
    },
};
</script>

<style scoped>
.intro-text {
    white-space: pre-wrap;
    font-family: inherit;
    font-size: 0.95rem;
    background: transparent;
    border: none;
    padding: 0;
}
</style>
